import { render, staticRenderFns } from "./DetailManage.vue?vue&type=template&id=63d21d54"
import script from "./DetailManage.vue?vue&type=script&lang=js"
export * from "./DetailManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports